import React, { Component } from 'react';
import PropTypes from 'prop-types';
import styled from 'react-emotion';
import classnames from 'classnames';
import Bullet from './bullet';

const Name = styled.div`
  color: #333;
  font-weight: bold;
  font-size: 29px;
  width: 100%;
  line-height: 68px;
  
  &.large {
    font-size: 30px;
  }
`;


class Definition1 extends Component {
    render() {
        const { large, name } = this.props;
        return (
            <div style={{ marginTop: '25px' }}>
                <Name className={classnames({ large })}><Bullet />{name}</Name>
            </div>
        );
    }
}

Definition1.propTypes = {
    name: PropTypes.string.isRequired,
    large: PropTypes.bool,
};
Definition1.defaultProps = {
    large: false
};

export default Definition1;



// WEBPACK FOOTER //
// ./src/components/definition1.jsx